export default __webpack_public_path__ + "static/media/Group 8534.f16b6b2b.jpg";